import {
  DealAssigneeRole,
  ParticipantRole,
  DealHealth,
  DocumentCategory,
  FinancingContingencyMode,
  LoanType,
  NextStepStatus,
  PurchaseMethod,
  SnapshotOwner,
} from "@/enum/common.enum";

/** Tone presets for the AI listing writer — sent verbatim as the prompt's tone brief. */
export const AI_LISTING_TONE_OPTIONS = [
  { value: "premium and warm", label: "Premium & warm" },
  { value: "modern and minimal", label: "Modern & minimal" },
  { value: "classic and editorial", label: "Classic & editorial" },
  { value: "bright and family-forward", label: "Bright & family-forward" },
];

export const SNAPSHOT_OWNER_OPTIONS = [
  { value: SnapshotOwner.UNASSIGNED, label: "Unassigned" },
  { value: SnapshotOwner.AGENT, label: "Agent" },
  { value: SnapshotOwner.COORDINATOR, label: "Coordinator" },
  { value: SnapshotOwner.CLIENT, label: "Client" },
  { value: SnapshotOwner.LENDER, label: "Lender" },
  { value: SnapshotOwner.ATTORNEY, label: "Attorney" },
  { value: SnapshotOwner.CO_AGENT, label: "Co Agent" },
];

export const SNAPSHOT_STATUS_OPTIONS = [
  { value: NextStepStatus.NOT_STARTED, label: "Not started" },
  { value: NextStepStatus.IN_PROGRESS, label: "In progress" },
  { value: NextStepStatus.DONE, label: "Done" },
];

export const SNAPSHOT_HEALTH_OPTIONS = ["", DealHealth.AHEAD, DealHealth.ON_TRACK, DealHealth.AT_RISK];

export const PURCHASE_METHOD_OPTIONS = [
  { value: PurchaseMethod.FINANCED, label: "Financed" },
  { value: PurchaseMethod.CASH, label: "Cash" },
];

export const LOAN_TYPE_OPTIONS = [
  { value: LoanType.CONVENTIONAL, label: "Conventional" },
  { value: LoanType.FHA, label: "FHA" },
  { value: LoanType.VA, label: "VA" },
  { value: LoanType.JUMBO, label: "Jumbo" },
  { value: LoanType.USDA, label: "USDA" },
  { value: LoanType.OTHER, label: "Other" },
];

export const FINANCING_CONTINGENCY_OPTIONS = [
  { value: FinancingContingencyMode.DAYS, label: "Days from contract", testId: "ds-form-fin-mode-days" },
  { value: FinancingContingencyMode.DATE, label: "Specific date", testId: "ds-form-fin-mode-date" },
];

/**
 * Roles you can invite into a deal.
 *
 * Note there is no plain "Agent": an agent inside your own brokerage already has
 * access through their org membership, and an agent on the other side of the
 * transaction is a `co_agent`. The old list offered "Agent", which the backend
 * rejects — `ParticipantRole` has never included it.
 */
export const PARTICIPANT_ROLE_VALUES = [
  ParticipantRole.CLIENT,
  ParticipantRole.CO_AGENT,
  ParticipantRole.LENDER,
  ParticipantRole.ATTORNEY,
  ParticipantRole.VENDOR,
];
export const DOCUMENT_CATEGORIES = Object.values(DocumentCategory);

export const FIRST_DEAL_CLIENT_DEFAULT_VALUES = { email: "", name: "" };
export const FIRST_DEAL_COLLABORATOR_DEFAULT_VALUES = { lender_email: "", attorney_email: "" };
